<template>
	<div class="col-12 col-md-6 col-lg-4 d-flex">
		<div class="card event-card border-0 align-items-stretch w-100 rounded-0 position-relative">

			<!-- Card image -->
			<template v-if="true == useHardLink && showPictureTag">
				<a :href="model.link" class="ratio ratio-4x3 overflow-hidden position-relative w-100">
					<event-picture :image="modelImages" :alt="model.title" :classes="['cover-img']"></event-picture>
				</a>
			</template>

			<div class="card-body d-flex flex-column justify-content-between">
				<div class="card-wrapper position-relative">

					<div class="show-card-btn-wrap position-absolute top-0 end-0"
						v-if="model.field_external_booking && model.field_external_booking_link && !model.field_external_tickets_sold_out">
						<a :href="model.link"
							class="btn show-card-btn d-flex align-items-center justify-content-center rounded-0 position-relative btn-booknow">
							<span class="btn-text z-1 text-white position-relative">
								Book now <i class="fa-light fa-arrow-right ms-1"></i>
							</span>
						</a>
					</div>

					<div class="show-card-btn-wrap position-absolute top-0 end-0"
						v-if="model.field_external_booking && model.field_external_booking_link && model.field_external_tickets_sold_out">
						<a :href="model.link"
							class="btn show-card-btn d-flex align-items-center justify-content-center rounded-0 position-relative btn-soldout">
							<span class="btn-text z-1 text-white position-relative">
								Sold out <i class="fa-light fa-arrow-right ms-1"></i>
							</span>
						</a>
					</div>

					<!-- Show ticket button if event is on sale. -->
					<div class="show-card-btn-wrap position-absolute top-0 end-0" v-if="model.field_is_on_sale && !modelIsOnPrioritySale">
						<!-- If tickets remaining is less than 50, show last remaining. -->
						<a v-if="model.field_tickets_remaining > 0 && model.field_tickets_remaining <= 50"
							:href="model.link"
							class="btn show-card-btn d-flex align-items-center justify-content-center rounded-0 position-relative btn-lastfew">
							<span class="btn-text z-1 text-white position-relative">
								Last few <i class="fa-light fa-arrow-right ms-1"></i>
							</span>
						</a>
						<!-- If tickets remaining is greater than 50, show book now. -->
						<a v-if="model.field_tickets_remaining > 50" :href="model.link"
							class="btn show-card-btn d-flex align-items-center justify-content-center rounded-0 position-relative btn-booknow">
							<span class="btn-text z-1 text-white position-relative">
								Book now <i class="fa-light fa-arrow-right ms-1"></i>
							</span>
						</a>
						<!-- If tickets remaining is 0, show Returns only. -->
						<a v-if="model.field_tickets_remaining == 0" :href="model.link"
							class="btn show-card-btn d-flex align-items-center justify-content-center rounded-0 position-relative btn-soldout">
							<span class="btn-text z-1 text-white position-relative">
								Sold out <i class="fa-light fa-arrow-right ms-1"></i>
							</span>
						</a>
					</div>

					<!-- Show ticket button if event is on Priority sale. -->
					<div class="show-card-btn-wrap position-absolute top-0 end-0" v-if="modelIsOnPrioritySale">
						<a :href="model.link"
							class="btn show-card-btn d-flex align-items-center justify-content-center rounded-0 position-relative btn-priority">
							<span class="btn-text z-1 text-white position-relative">
								Priority Booking <i class="fa-light fa-arrow-right ms-1"></i>
							</span>
						</a>
					</div>

					<!-- Title -->
					<h3 class="card-title h4 mb-1" v-if="model.title">
						<template v-if="true == useHardLink">
							<a :href="model.link" v-html="model.title" class="show-card-title"></a>
						</template>
					</h3>

					<!-- Dates
					<p v-if="model.field_event_start_date" class="mb-0">
						<strong>
							{{ formatDate(model.field_event_start_date) }}
							<template v-if="model.field_event_end_date">
								- {{ formatDate(model.field_event_end_date) }}
							</template>
						</strong>
					</p>
					-->
					<p v-if="model.field_date_display" class="mb-0">
						<strong>
							{{ model.field_date_display }}
						</strong>
					</p>

					<p class="mb-1">
						<strong>
							<span v-if="model.field_show_time">{{ model.field_show_time }}</span>
							<span v-if="model.field_price_display" class="border-start border-dark ms-2 ps-2">{{ model.field_price_display }}</span>
						</strong>
					</p>

					<!-- Excerpt -->
					<div class="post-excerpt" v-if="true == useHardLink && model.excerpt">
						<small>{{ model.excerpt }}</small>
					</div>

					<!-- Genres -->
					<div class="genres d-flex mt-2 text-quinary" v-if="model.terms_shows_genre">
						<span v-for="tag in model.terms_shows_genre" :key="tag.id"
							class="genre-tag position-relative"><small>{{ tag.name }}</small></span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import EventPicture from '@/components/EventPicture.vue';

export default {
	name: 'EventCard',
	props: {
		model: Object
	},
	components: {
		EventPicture,
	},
	data() {
		return {
			useHardLink: ('1' === process.env.VUE_APP_USE_SINGLE_POST_HARD_LINK || false),
		}
	},
	computed: {
		showPictureTag() {
			if (this.model.images && Object.keys(this.model.images).length && this.model.images.full && this.model.images.full.url) {
				return true;
			}
			if (this.model.thumbnail_images && Object.keys(this.model.thumbnail_images).length && this.model.thumbnail_images.full && this.model.thumbnail_images.full.url) {
				return true;
			}
			return false
		},
		modelImages() {
			return Object.keys(this.model.thumbnail_images).length > 0 ? this.model.thumbnail_images : this.model.images;
		},
		modelIsOnPrioritySale() {
			return this.model.field_is_on_sale && this.model.field_is_on_priority_sale;
		}
	},
	methods: {
		formatDate(date) {

			if (!date) {
				return null
			}

			const d = new Date(date)

			if (isNaN(d)) {
				return d
			}

			return this.dateDay(d.getDay()) +
				' ' + d.getDate() +
				this.dateOrdinal(d.getDate()) +
				' ' + d.toLocaleString('default', { month: 'short' }) +
				' ' + d.getFullYear()
		},
		dateOrdinal(d) {
			if (d > 3 && d < 21) return 'th';
			switch (d % 10) {
				case 1: return "st";
				case 2: return "nd";
				case 3: return "rd";
				default: return "th";
			}
		},
		dateDay(d) {
			const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
			return daysOfWeek[d];
		}
	}
}
</script>
